import type { InjectionKey } from 'vue';
import {
  createStore, createLogger, Store, useStore as baseUseStore,
} from 'vuex';
import auth from './auth';
import type { AuthState } from './auth';

const debug = process.env.NODE_ENV !== 'production';

export interface State {
  auth: AuthState
}

export const key: InjectionKey<Store<State>> = Symbol('vuex-state');

export default createStore<State>({
  modules: {
    auth,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});

export function useStore() {
  return baseUseStore(key);
}
